export default "__VITE_ASSET__CuP1E4IN__"